import ContainedIcon from '@/components/ContainedIcon';
import DeepSeekIconBase from '@/components/Icons/DeepSeekIcon';

function DeepSeekIcon() {
  return (
    <ContainedIcon size={24} color="#4D6BFE" borderRadius={6}>
      <DeepSeekIconBase
        sx={{
          width: 16,
          height: 16,
          color: 'white',
        }}
      />
    </ContainedIcon>
  );
}

export default DeepSeekIcon;
